import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "../Logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Land Pooling", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Maps", path: "/maps" },
    { name: "Marketplace", path: "/marketplace" },
    { name: "Knowledge Hub", path: "/knowledge-hub" },
  ];

  const services = [
    { name: "Land Pooling Process", path: "/services#land-pooling" },
    { name: "Consortium Management", path: "/services#consortium" },
    { name: "Agreement Formats", path: "/services#agreements" },
    { name: "Voting Management", path: "/services#voting" },
    { name: "RFP & Bid Management", path: "/services#rfp" },
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container-main py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Logo variant="light" size="md" />
            </Link>
            <p className="text-sm text-slate-400 mb-4">
              Simplifying land pooling and consortium management for sustainable
              urban development.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <a
                href="mailto:terratoryconsultants@gmail.com"
                className="flex items-center gap-2 hover:text-white transition-colors"
                data-testid="footer-email-link"
              >
                <Mail className="w-4 h-4" />
                terratoryconsultants@gmail.com
              </a>
              <div className="flex items-start gap-2" data-testid="footer-phone-list">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div className="flex flex-col">
                  <a
                    href="tel:+917982094064"
                    className="hover:text-white transition-colors"
                    data-testid="footer-phone-1"
                  >
                    +91 79820 94064
                  </a>
                  <a
                    href="tel:+919899975205"
                    className="hover:text-white transition-colors"
                    data-testid="footer-phone-2"
                  >
                    +91 98999 75205
                  </a>
                  <a
                    href="tel:+919899361123"
                    className="hover:text-white transition-colors"
                    data-testid="footer-phone-3"
                  >
                    +91 98993 61123
                  </a>
                  <a
                    href="tel:+919711536248"
                    className="hover:text-white transition-colors"
                    data-testid="footer-phone-4"
                  >
                    +91 97115 36248
                  </a>
                </div>
              </div>
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                New Delhi, India
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              Our Services
            </h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-sm hover:text-white transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/disclaimer"
                  className="text-sm hover:text-white transition-colors"
                >
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link
                  to="/refund"
                  className="text-sm hover:text-white transition-colors"
                >
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">
            © {currentYear} Terratory Consultants. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Powered by Land Pooling Technology
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
